import { Navigate, Route } from 'react-router-dom';
import AdminLogin from '../../admin/login/Login';
import AdminRestaurants from '../../admin/restaurants/AdminRestaurants';
import AdminUsers from '../../admin/users/AdminUsers';
import AdminShell from '../../admin/shell/AdminShell';
import { useAuth } from '../../context/AuthContext';
import AdminLayout from './layout';
import RequireAuth from './RequireAuth';

const GuestOnly = () => {
  const { isAuthenticated, isSuperAdmin } = useAuth();
  if (isAuthenticated && isSuperAdmin) return <Navigate to="/admin" replace />;
  return <AdminLogin />;
};

export const adminRoutes = (
  <Route path="admin" element={<AdminLayout />}>
    <Route path="login" element={<GuestOnly />} />
    <Route element={<RequireAuth />}>
      <Route element={<AdminShell />}>
        <Route index element={<Navigate to="restaurants/active" replace />} />
        <Route path="restaurants/active" element={<AdminRestaurants key="active" status="active" />} />
        <Route path="restaurants/inactive" element={<AdminRestaurants key="inactive" status="inactive" />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Route>
  </Route>
);
